import React from "react";

export default function TextField({ id, label, required, type = "text", value, onChange, placeholder, name, maxLength }) {
  const currentLength = value ? String(value).length : 0;
  const isClose = maxLength && currentLength > maxLength * 0.9;
  const isMax = maxLength && currentLength >= maxLength;

  return (
    <div>
      <label htmlFor={id} style={{ display: 'block', marginBottom: 8, fontWeight: 500, color: '#374151' }}>
        {label} {required && <span style={{ color: '#dc2626' }}>*</span>}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => onChange?.(name || id, e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '1rem' }}
      />
      {maxLength && (
        <div style={{
          fontSize: '0.75rem',
          color: isMax ? '#dc2626' : (isClose ? '#d97706' : '#6b7280'),
          textAlign: 'right',
          marginTop: 4,
          fontFamily: "'Barlow', sans-serif",
        }}>
          {currentLength}/{maxLength}
        </div>
      )}
    </div>
  );
}

